import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  canActivateDataSource,
  SimpleViewComponent,
  ViewsLocalStorageService,
} from '@core/views-legacy';
import { WrappedTableListGroupHeadingComponent } from '@core/views-ui';
import {
  dataSourceProviders,
  provideListLayout,
  provideViewBaseRoute,
  provideViewDataScope,
} from '@core/views-util';

import { UserTemplatesDataSourceService } from './user-templates-data-source.service';
import { UserFormListItemComponent } from './user-templates-list-item/user-form-list-item.component';

@Component({
  selector: 'tlc-user-forms-view',
  template: `
    @if (canActivate()) {
      <rt-simple-view
        class="view"
        viewId="ask_templates:active"
        [selfScrollEnabled]="true"
        [hasControls]="false"
        forcedLayout="list"
      />
    }
  `,
  imports: [SimpleViewComponent],
  providers: [
    ViewsLocalStorageService,
    provideViewBaseRoute('/asks/templates'),
    UserTemplatesDataSourceService,
    dataSourceProviders('ask_templates', {
      ask_templates: UserTemplatesDataSourceService,
    }),
    provideViewDataScope({ useValue: 'ask-templates-user' }),
    provideListLayout({
      ask_templates: {
        header: WrappedTableListGroupHeadingComponent,
        record: UserFormListItemComponent,
        recordSettings: {
          hasPadding: false,
        },
      },
    }),
  ],
  styleUrls: ['./user-templates-view.component.less'],
})
export class TellentUserTemplatesViewComponent {
  private readonly canActivateFn = canActivateDataSource();
  private readonly canActivate$ = this.canActivateFn();
  protected canActivate = toSignal(this.canActivate$);
}
